import { useEffect, useState } from "react";

// "Comunicação"/"Posição" com horário + há quanto tempo (pedido 2026-10-23):
// "14:32 · agora", "14:32 · há 5 min", "21/10 10:40 · há 2 dias". Mesmo
// formato em todas as telas que mostram esses dados.

export function agoLabel(iso: string | null | undefined, now = Date.now()): string {
  const t = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(t) || t <= 0) return "nunca";
  const min = Math.max(0, Math.floor((now - t) / 60_000));
  if (min < 1) return "agora";
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return min % 60 ? `há ${h} h ${min % 60} min` : `há ${h} h`;
  const d = Math.floor(h / 24);
  return `há ${d} ${d === 1 ? "dia" : "dias"}`;
}

export function clockLabel(iso: string | null | undefined, now = Date.now()): string | null {
  const t = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(t) || t <= 0) return null;
  const d = new Date(t);
  const hm = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  if (d.toDateString() === new Date(now).toDateString()) return hm;
  const dm = d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
  return d.getFullYear() === new Date(now).getFullYear() ? `${dm} ${hm}` : `${d.toLocaleDateString("pt-BR")} ${hm}`;
}

export function timeWithAgo(iso: string | null | undefined, now = Date.now()): string {
  const clock = clockLabel(iso, now);
  return clock ? `${clock} · ${agoLabel(iso, now)}` : "Nunca";
}

// Relógio pra o "há X min" subir sozinho com a tela aberta.
export function useNowTick(ms = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
}
